import { Card, CardHeader, Typography, Button, CircularProgress, CardContent, Divider, Grid, Stack, Box } from "@mui/material";
import { FC } from "react";
import { GreenJobs, YellowJobs, RedJobs } from "../dashboard/statusBadge";
import ArrowRightIcon from '@/icons/ArrowRight';
import AddIcon from '@mui/icons-material/Add';
import NavigationRefresh from '@mui/icons-material/Refresh';
import { useShowContext, ReduxState, useRefresh } from "ra-core";
import { useSelector } from "react-redux";
import { RecPatch } from "@/dataProvider/tools";
import { Link as RouterLink } from 'react-router-dom'
import { DeploymentDashboardResponseDto } from "@/gen/api/deploy";
import { useHasPermit } from "@/authProvider/useHasPermit";
import { MANAGE_DATABASE_DEPLOYMENTS } from "@/constants";



const DeploymentStatusCard: FC = () => {
  const hasWritePermit = useHasPermit([MANAGE_DATABASE_DEPLOYMENTS])
  const { record } = useShowContext<DeploymentDashboardResponseDto & RecPatch>()
  const loading = useSelector<ReduxState>(state => state.admin.loading > 0);
  const refresh = useRefresh()

  return (
    <Card>
      <CardHeader 
        sx={{ pb: 0 }}
        title={(
          <Typography variant="h6" color="textPrimary">
            Deployment Status
          </Typography>
        )}
        action={(
          <Button
            size="small"
            startIcon={loading ?<CircularProgress size={14} /> : <NavigationRefresh />}
            color="secondary"
            onClick={() => refresh()}
          >
            Refresh
          </Button>)}
      />
      <CardContent>
        <Divider sx={{ mb: 1 }} />
        <Grid container direction="row" sx={{ mt: 1 }}>
          <Grid item xs={6}>
            <Typography
              color="textSecondary"
              variant="overline"
            >
              Databases
            </Typography>
            <Stack 
              component="ul"
              direction="column"
              sx={{ pl: 'unset', mt: 2, mb: 1, }}
            >
              <GreenJobs count={record?.deploymentSuccessCount || 0} />
              <YellowJobs count={record?.deploymentWarningCount || 0} />
              <RedJobs count={record?.deploymentFailedCount || 0} />
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Box
              sx={{
                mt: 4,
                alignItems: 'normal',
                display: 'flex',
                flexDirection: 'column',
                '& .MuiButton-root': {
                  mb: 1.5,
                },
              }}
            >
              <Button
                color="primary"
                endIcon={<ArrowRightIcon fontSize="small" />}
                variant="outlined"
                component={RouterLink}
                to="/deployments/list"
              >
                View Deployments
              </Button>
              {hasWritePermit &&
                <Button
                  color="primary"
                  startIcon={<AddIcon fontSize="small" />}
                  variant="outlined"
                  component={RouterLink}
                  to={{
                    pathname: "/deployments/list",
                    state: { openCreate: true },
                  }}
                >
                  Deploy Databases
                </Button>}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default DeploymentStatusCard;
